<nb-card>
  <nb-card-header>
    <div class="summary">
      <div class="item">
        <div class="avatar">
          <nb-user
            [name]="history.fullName"
            [onlyPicture]="true"
            size="large"
            (click)="viewProfile(history.id)"
          ></nb-user>
        </div>

        <div>
          <a (click)="viewProfile(history.id)" class="link">
            <strong>
              {{ history.fullName ? history.fullName : "Anonymous" }} -
              {{ history.dobYear ? history.dobYear : "20xx" }}
            </strong>
          </a>
          <ngx-view-time-ago
            [currentDate]="history.createdOn"
          ></ngx-view-time-ago>

          <div>
            <button
              nbButton
              ghost
              size="small"
              [status]="
                history.value == 1
                  ? 'success'
                  : history.value == 0
                  ? 'info'
                  : 'danger'
              "
            >
              <nb-icon icon="activity-outline"></nb-icon>
              <span> {{ history.status }} </span>
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="button-action">
      <button
        *ngIf="history.createdBy === uid"
        nbButton
        ghost
        status="danger"
        size="small"
        [disabled]="submitted"
        [class.btn-pulse]="submitted"
        (click)="delete(history)"
      >
        <nb-icon icon="trash-2-outline"></nb-icon>
      </button>

      <button
        *ngIf="history.createdBy === uid"
        nbButton
        ghost
        status="info"
        size="small"
        [disabled]="submitted"
        [class.btn-pulse]="submitted"
        (click)="edit(history)"
      >
        <nb-icon icon="edit-2-outline"></nb-icon>
      </button>
    </div>
  </nb-card-header>

  <nb-card-body>
    <div>
      {{ "common.note" | translate }}:
      <span class="text-hint" style="white-space: pre">
        {{ history.description }}
      </span>
    </div>

    <!-- <a *ngIf="!isMore" (click)="loadContent(true)" class="link">
      <nb-icon icon="chevron-down-outline"></nb-icon>
      Xem chi tiết
    </a>

    <nb-card *ngIf="isMore">
      <nb-card-body>
        <ul class="detail">
          {{'common.note' | translate}}:
          <span class="text-hint" style="white-space: pre">{{
            history.description
          }}</span>
        </ul>
        <ngx-view-gallery
          *ngIf="history.imagesUrl.length > 0"
          [imagesUrl]="history.imagesUrl"
        >
        </ngx-view-gallery>
      </nb-card-body>
    </nb-card>

    <a *ngIf="isMore" (click)="loadContent(false)" class="link">
      <nb-icon icon="chevron-up-outline"></nb-icon>
      
    </a> -->
  </nb-card-body>
</nb-card>
